export default {
    getUsuario: (state) => state.usuario,
    getPagination: (state) => state.pagination,
    getIndicadores: (state) => state.indicadores,
    getListaInscricoes: (state) => state.listaInscricoes || [],
    getListaEditais: (state) => state.listaEditais || [],
    getEditaisOpcoes: (state) => (state.listaEditais || []).map((edital) => ({
        ...edital,
        rotulo: edital.numero ? `${edital.numero} - ${edital.titulo}` : edital.titulo,
    })),
    getEditaisVigentes: (state) => (state.listaEditais || []).filter((edital) => edital.situacao === 'Aberto'),
    getMinhaInscricao: (state) => state.minhaInscricao,
    getDocumentosExigidos: (state) => state.documentosExigidos || [],
    getDocumentosExigidosDoEdital: (state) => (editalId) => {
        const edital = (state.listaEditais || []).find((item) => item.id === Number(editalId));
        if (!edital) return [];

        return (edital.documentosExigidos || [])
            .map((doc) => {
                const tipo = (state.listaTiposDocumento || []).find((item) => item.id === doc.tipoDocumentoId);
                return {
                    id: Number(doc.tipoDocumentoId),
                    descricao: tipo ? tipo.descricao : `Documento ${doc.tipoDocumentoId}`,
                    obrigatorio: doc.obrigatorio,
                    ordem: doc.ordem,
                    limiteAnexos: tipo ? (tipo.limiteAnexos || 1) : 1,
                };
            })
            .sort((a, b) => a.ordem - b.ordem);
    },
    getListaTiposDocumento: (state) => state.listaTiposDocumento || [],
    getCatalogoTiposDocumento: (state) => state.catalogoTiposDocumento || [],
    getListaEspecialidades: (state) => state.listaEspecialidades || [],
    getListaAreasAtuacao: (state) => state.listaAreasAtuacao || [],
    getListaUsuarios: (state) => state.listaUsuarios || [],
    getListaPagamentos: (state) => state.listaPagamentos || [],
};
